import React from 'react';
import styled from 'styled-components';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  height: 300px;
  padding: 0;
  padding-top: calc(var(--nav-height) + 30px);

  h1 {
    margin: 0 0 15px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 10px 2px;
    }
  }

  h2.big-heading {
    font-size: clamp(20px, 4vw, 40px);
    margin-bottom: 10px;
  }

  h3.big-heading {
    font-size: clamp(16px, 3vw, 28px);
    margin: 5px 0 15px 0;
    color: var(--slate);
    line-height: 1.1;
  }

  p {
    margin: 0;
    max-width: 700px;
  }
`;

const Hero = () => {
  return (
    <StyledHeroSection>
      <h1>Hi, my name is</h1>
      <h2 className="big-heading">Vincent. </h2>
      <h3 className="big-heading">
        Welcome to my corner of the internet where i figure things out.
      </h3>
      <p>
        Dad of two boys sharing my adventures in building stuff, breaking things, and figuring out
        why things don't work while trying not to mess up parenting too badly.
      </p>
    </StyledHeroSection>
  );
};

export default Hero;
